import React from 'react';
import {NavLink} from 'react-router-dom';

const styleName = {
    fontWeight:"bold",
    fontSize:"15px",
    textAlign:"left",
    // display: "inline"
}
const styleValue = {
    fontWeight:"bold",
    fontSize:"15px",
    textAlign:"right",
    valign:"top",
    // display: "inline", 
    // float: "right", 
    // padding: "0 10px"
}

const Row = (props) => {
    const urls = props.urls !== undefined && props.urls && Array.isArray(props.urls) ? [...props.urls] : [];
    return (
        <tr style={props.styleRow}>
            <td style={styleName}><span>{props.name}</span></td>
            {
                props.values.map((value, key) => {
                    if(urls[key] !== undefined && urls[key]) {
                        return <td key={key} style={styleValue}><NavLink exact to={urls[key]}><span>&nbsp;{value}&nbsp;</span></NavLink></td> 
                    }
                    return <td key={key} style={styleValue}><span>&nbsp;{value}&nbsp;</span></td>
                })
            }
        </tr>
    )
};

export default React.memo(Row);